module.exports = __webpack_public_path__ + "img/tablet1.146561ba.jpg";